import { css } from '@emotion/core';
import { getComponentName, getStoryName } from '../Story/StoryPage.utils';

export function getCssPills() {
  return css`
    margin-left: 20px;
    @media (max-width: 768px) {
      display: none;
    }
  `;
}

export function getCssLink() {
  return css`
    font-size: 30px;
    color: #fff;
    padding: 0px 20px;
    text-decoration: none;
    @media (max-width: 768px) {
      display: none;
    }
  `;
}

export function getCssMainDiv(docsDarkMode: boolean) {
  return css`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100vh;
    min-width: 200px;
    max-width: 200px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 15px 0px;
    background-color: ${docsDarkMode ? '#000' : '#2d3748'};
    @media (max-width: 420px) {
      display: none;
    }
    transition: min-width 0.3s;
  `;
}

export function getCssForDivSearch() {
  return css`
    display: block;
    align-items: center;
    margin: 15px 20px 0px;
    @media (max-width: 768px) {
      display: 'block'};
    }
  `;
}

export function getCssforDivExpanded() {
  return css`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    @media (max-width: 768px) {
      display: 'flex'};
    }
  `;
}

export function getCssForInputSearch(fontFamily: any, docsDarkMode: boolean) {
  return css`
    box-sizing: border-box;
    border: 0;
    border-radius: 3px;
    background-color: ${docsDarkMode ? '#383838' : '##4a5568'};
    font-family: ${fontFamily};
    font-size: 14px;
    color: ${docsDarkMode ? '#fff' : '#000'};
    padding: 5px 10px;
    margin: 10px 0px;
    width: 100%;
    :focus {
      outline: none;
    }
    ::placeholder {
      color: #a0aec0;
    }
  `;
}

export function getCssForStoryTitleButton(
  selected: boolean,
  fontFamily: any,
  docsDarkMode: boolean,
) {
  return css`
    display: block;
    border: none;
    color: #fff;
    background-color: ${selected ? (docsDarkMode ? '#383838' : '#4A5568') : 'transparent'};
    text-align: left;
    font-family: ${fontFamily};
    font-size: 13px;
    cursor: pointer;
    min-height: 35px;
    margin: 0px 1px;
    padding: 0px 30px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    :focus {
      outline-color: ${docsDarkMode ? '#383838' : '#718096'};
      outline: none;
    }
    :hover {
      background-color: ${docsDarkMode ? '#383838' : '#718096'};
    }
    @media (max-width: 768px) {
      padding: '0px 40px';
    }
  `;
}

export function getCssForGroupButton(selected: boolean, fontFamily: any, docsDarkMode: boolean) {
  return css`
    border: none;
    background-color: ${selected ? (docsDarkMode ? '#383838' : '#4A5568') : 'transparent'};
    text-align: left;
    font-family: ${fontFamily};
    font-size: 15px;
    color: #edf2f7;
    cursor: pointer;
    min-height: 35px;
    margin: 0px 1px;
    padding: 0px 20px;
    :focus {
      outline-color: ${docsDarkMode ? '#383838' : '#718096'};
      outline: none;
    }
    :hover {
      background-color: ${docsDarkMode ? '#383838' : '#718096'};
    }
  `;
}

export function getCssForSectionButton(
  fontFamily: any,
  type: string,
  selectable: boolean,
  docsDarkMode: boolean,
) {
  return css`
    border: none;
    background-color: transparent;
    text-align: left;
    font-family: ${fontFamily};
    font-size: ${type === 'section' ? '14px' : '15px'};
    font-weight: ${type === 'section' ? '600' : undefined};
    color: ${type === 'section' ? '#929597' : '#edf2f7'};
    min-height: ${type === 'section' ? '25px' : '35px'};
    margin: ${type === 'section' ? '20px 1px 0px 1px' : '0px 1px 0px 1px'};
    padding: 0px 20px;
    text-transform: ${type === 'section' ? 'uppercase' : undefined};
    cursor: ${selectable ? 'pointer' : 'default'};
    :focus {
      background-color: ${docsDarkMode ? '#383838' : '#4a5568'};
      outline: none;
    }
    :hover {
      background-color: ${docsDarkMode ? '#383838' : '#718096'};
    }
  `;
}

export function getNavDefaultValues(location: any) {
  let pageType = location.pathname.toLowerCase().replace('/', '');
  let defaultSelectedGroup = '';
  let defaultSelectedItem = '';
  if (pageType === 'story') {
    defaultSelectedGroup = getComponentName(location);
    defaultSelectedItem = getStoryName(location);
  }
  return {
    defaultSelectedGroup,
    defaultSelectedItem,
  };
}
